import React from "react";

import logo from "../assets/Dai.svg";

export function UrsidaiLogo(props: { width?: number; height?: number }) {
  const width = props.width ?? 100;
  const height = props.height ?? 100;
  return <img src={logo} alt="Ursidai Logo" width={width} height={height} />;
}
